import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from './Logo';
import BurgerMenu from './BurgerMenu';

const Header = ({ showMenu = true, onProfileClick, onPointsClick }) => {
  return (
    <motion.header 
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 p-6 md:p-8 flex items-center justify-between z-50 pointer-events-none"
      data-testid="header"
    >
      {/* Logo */}
      <Link 
        to="/"
        className="transition-opacity duration-300 hover:opacity-80 pointer-events-auto"
        data-testid="logo-link"
      >
        <Logo size="default" />
      </Link>

      {/* Burger Menu */}
      {showMenu && (
        <div className="pointer-events-auto">
          <BurgerMenu 
            onProfileClick={onProfileClick}
            onPointsClick={onPointsClick}
          />
        </div>
      )}
    </motion.header>
  );
};

export default Header;
